jQuery(document).ready(function ($) {
    // Elements class names
    const ELEMENTS = {
        SITE_HEADER : 'site-header',
        SIDEBAR_NAVIGATION_CONTENT_BLOCKS: 'block-sidebar-navigation-content-blocks',
        SIDEBAR_NAVIGATION_CONTENT_BLOCKS_CONTENT_BLOCK: 'block-sidebar-navigation-content-blocks__content-blocks__content-block',
        SIDEBAR_NAVIGATION_CONTENT_BLOCKS_CONTENT_BLOCK_TITLE: 'block-sidebar-navigation-content-blocks__content-blocks__content-block__title',
        SIDEBAR_NAVIGATION_CONTENT_BLOCKS_SIDEBAR: 'block-sidebar-navigation-content-blocks__sidebar',
        SIDEBAR_NAVIGATION_CONTENT_BLOCKS_SIDEBAR_TAB: 'block-sidebar-navigation-content-blocks__sidebar__tab',
        SIDEBAR_NAVIGATION_CONTENT_BLOCKS_SIDEBAR_TAB_ACTIVE: 'block-sidebar-navigation-content-blocks__sidebar__tab--active',
        SIDEBAR_NAVIGATION_CONTENT_BLOCKS_CONTENT_TAB_INACTIVE: 'block-sidebar-navigation-content-blocks__sidebar__tab--inactive'
    }
    const sidebarNavigationContentBlocks = $(`.${ELEMENTS.SIDEBAR_NAVIGATION_CONTENT_BLOCKS}`);

    // Early exit if no block on the page
    if (sidebarNavigationContentBlocks.length === 0) {
        return;
    }

    // --------------------------------------------
    // Functions
    // --------------------------------------------
    /**
     * Check if an element is the most visible element in the viewport
     * If another element with the selector is visible in the viewport, return false
     * @param $element
     * @param selector
     * @returns {boolean}
     */
    const isMostVisibleInViewport = ($element, selector) => {
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        // Helper to calculate how much of the element is visible vertically
        const getVisibleHeight = (el) => {
            const rect = el.getBoundingClientRect(),
                visibleTop = Math.max(0, rect.top),
                visibleBottom = Math.min(windowHeight, rect.bottom);
            return Math.max(0, visibleBottom - visibleTop);
        }

        const currentVisible = getVisibleHeight($element[0]);
        if (currentVisible === 0) return false; // Not in viewport at all

        let isMoreVisible = true;

        // Loop through all elements with the selector and check if they are more visible
        $(selector).each(function () {
            if (this !== $element[0]) {
                const otherVisible = getVisibleHeight(this);
                if (otherVisible > currentVisible) {
                    isMoreVisible = false;
                    return false; // break out of loop early
                }
            }
        });

        return isMoreVisible;
    }

    /**
     * Dynamically adjust the top of the sidebar based on the size of the sticky header
     */
    const positionSidebar = () => {
        const sidebar = $(`.${ELEMENTS.SIDEBAR_NAVIGATION_CONTENT_BLOCKS_SIDEBAR}`);

        // Early exit if no sidebar found
        if (sidebar.length === 0) {
            return;
        }

        // Get the header height
        const headerHeight = $(`.${ELEMENTS.SITE_HEADER}`).outerHeight();

        if (sidebar.css('top') !== `${headerHeight}px`) {
            sidebar.css('top', `${headerHeight}px`);
        }
    }

    /**
     * Scroll to the correct section
     * @param link
     * @param e
     */
    const scrollToSection = (link, e) => {
        // We need to replace any '&' OR '|' in the links with '\\&' OR '\\|'
        // In Jquery the '&' AND '|' is reserved
        if (link.indexOf('&') >= 0 || link.indexOf('|') >= 0) {
            link = link.replace('&', '\\&');
            link = link.replace('|', '\\|');
        }

        const target = $(`${link}`);
        const headerHeight = $(`.${ELEMENTS.SITE_HEADER}`).outerHeight();

        // Add a gap above the target, so the element does not stick to the header
        const gap = '20';

        // Calculate the offset from the top to scroll to the correct position accounting for the sticky header
        const offsetTop = target[0].getBoundingClientRect().top + window.scrollY - headerHeight - gap;

        // Stop default click functionality
        e.preventDefault();

        window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
        });
    }
    // --------------------------------------------
    // End Functions
    // --------------------------------------------

    // --------------------------------------------
    // Event listeners
    // --------------------------------------------
    // Window on load/scroll event listener
    $(window).on(('load scroll'), function () {
        $(`.${ELEMENTS.SIDEBAR_NAVIGATION_CONTENT_BLOCKS_CONTENT_BLOCK}`).each(function () {
            const element = $(this);

            // Check if element is visible and is the most visible in the viewport, if so, make it active in the sidebar navigation item
            if (element.is(':visible') && isMostVisibleInViewport(element, $(`.${ELEMENTS.SIDEBAR_NAVIGATION_CONTENT_BLOCKS_CONTENT_BLOCK}`))) {
                // Get the title of the current most visible element
                const title = element.find(`.${ELEMENTS.SIDEBAR_NAVIGATION_CONTENT_BLOCKS_CONTENT_BLOCK_TITLE}`).text().trim();
                const sidebarTabs = $(`.${ELEMENTS.SIDEBAR_NAVIGATION_CONTENT_BLOCKS_SIDEBAR_TAB}`);

                // Early exit, no sidebar tabs present on page
                if (sidebarTabs.length === 0) {
                    return;
                }

                sidebarTabs.each(function() {
                    if ($(this).text().trim() === title) {
                        $(this).removeClass(ELEMENTS.SIDEBAR_NAVIGATION_CONTENT_BLOCKS_CONTENT_TAB_INACTIVE);
                        $(this).addClass(ELEMENTS.SIDEBAR_NAVIGATION_CONTENT_BLOCKS_SIDEBAR_TAB_ACTIVE);
                    } else {
                        $(this).removeClass(ELEMENTS.SIDEBAR_NAVIGATION_CONTENT_BLOCKS_SIDEBAR_TAB_ACTIVE);
                        $(this).addClass(ELEMENTS.SIDEBAR_NAVIGATION_CONTENT_BLOCKS_CONTENT_TAB_INACTIVE);
                    }
                });
            }
        });
    });

    // Window on load/resize event listener
    $(window).on('load resize', function () {
        // Sidebar is only active for desktop viewport
        if (window.innerWidth > 1023) {
            positionSidebar();
        }
    });

    // On click event listener for sidebar buttons
    $(`.${ELEMENTS.SIDEBAR_NAVIGATION_CONTENT_BLOCKS_SIDEBAR} a`).on('click', function(e) {
        let link = $(this).attr('href');

        // Early exit, no link found on the clicked element
        if (link.length === 0) {
            return;
        }

        scrollToSection(link, e);
    });
    // --------------------------------------------
    // End Event listeners
    // --------------------------------------------
});